import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dark-layout',
    templateUrl: './dark-layout.component.html',
    styleUrls: ['./dark-layout.component.scss'],
    standalone: false
})
export class DarkLayoutComponent implements OnInit {

  constructor() { }

  public ngOnInit() : void {
  }

}
